module.exports = __webpack_public_path__ + "static/map-layers.a992b1f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/map-layers.png
// module id = 564
// module chunks = 195485404593854